"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconSsd = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.623 0a1 1 0 011 1v20.496a1 1 0 01-1 1h-5.301v-1.088h-4.77v1.088H4.5a1 1 0 01-1-1V1a1 1 0 011-1h15.123zm-.501 1.5H5v19.496h14.122V1.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.824 19.909a1 1 0 011 1V23a1 1 0 01-1 1h-5.77a1 1 0 01-1-1v-2.091a1 1 0 011-1h5.77zm-.501 1.499h-4.77v1.091h4.77v-1.091zm-1.717-10.16a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-3a1 1 0 011-1h3zm-.501 1.5h-2v2h2v-2zM6.657 4.831a1 1 0 100-2 1 1 0 000 2zm10.563 0a1 1 0 100-2 1 1 0 000 2zm0 15.078a1 1 0 100-2 1 1 0 000 2zm-10.563 0a1 1 0 100-2 1 1 0 000 2z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconSsd, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;